import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-xxl mx-auto mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row mt-5" }
const _hoisted_4 = { class: "col-xl-4 col-xxl-3 col-lg-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "mb-4 row align-items-center" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center d-none d-lg-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "Búsqueda de vehículo", -1)
const _hoisted_9 = { class: "fs-9 ms-3 text-gray" }
const _hoisted_10 = { class: "col-lg-12 col-xl-6 align-items-center mt-3 mt-xl-0 mt-lg-2" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col my-2 mb-4 d-none d-md-block text-xl-end" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fs-sm" }, " Ver: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fs-xs isax-element-3 text-white" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fs-xs isax-row-vertical text-white" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col my-2 mb-4 text-end pe-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "me-5 text-white fs-sm",
  for: ""
}, "Ordenar:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 mx-auto text-center noSearch" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: "/media/images/Sin vehículos.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "fs-1 fw-bold my-5" }, "No se encontraron vehículos"),
  /*#__PURE__*/_createElementVNode("p", { class: "my-5" }, "Modifica los filtros para encontrar más opciones.")
], -1)
const _hoisted_22 = {
  key: 0,
  class: "col-12 my-10 simil"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 fs-5" }, "También te pueden interesar", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-12 col-md-7 ms-auto d-flex align-items-center justify-content-end mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CardVehicle = _resolveComponent("CardVehicle")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: $setup.searchGlobal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchGlobal) = $event)),
        class: "w-100 fs-base",
        size: "large",
        onChange: $setup.searchDebouncer,
        clearable: "",
        onClear: $setup.searchDebouncer,
        placeholder: "Buscar vehículo"
      }, {
        suffix: _withCtx(() => [
          _createElementVNode("i", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.searchDebouncer && $setup.searchDebouncer(...args))),
            class: "isax-search-normal fs-4 pointer el-input__icon me-5 p-1"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange", "onClear"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.brands && $setup.years && $setup.locations && $setup.fuel && $setup.type)
          ? (_openBlock(), _createBlock(_component_Filters, {
              key: 0,
              prop_brands: $setup.brands,
              prop_years: $setup.years,
              prop_locations: $setup.locations,
              prop_fuel: $setup.fuel,
              prop_type: $setup.type,
              prop_trans: $setup.transmissions
            }, null, 8, ["prop_brands", "prop_years", "prop_locations", "prop_fuel", "prop_type", "prop_trans"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass($setup.classList)
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.paginate.total) + " resultados", 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeGrid('cards'))),
                    class: _normalizeClass(["btn btn-icon grid-btn w-25px h-25px ms-1", $setup.typeCard == 'cards' ? 'btn-primary' : 'btn'])
                  }, _hoisted_15, 2),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeGrid('list'))),
                    class: _normalizeClass([$setup.typeCard == 'list' ? 'btn-primary' : 'btn', "btn btn-icon grid-btn w-25px h-25px ms-1"])
                  }, _hoisted_17, 2)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_el_select, {
                      class: "w-100 pe-1 order",
                      placeholder: "Ordenar por:",
                      onChange: $setup.getVehicles,
                      modelValue: $setup.order,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.order) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Menor precio",
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Menor precio")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Mayor precio",
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mayor precio")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Menor Kilometraje",
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Menor Kilometraje")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Mayor Kilometraje",
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mayor Kilometraje")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Menor Año",
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Menor Año")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Mayor Año",
                          value: 6
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mayor Año")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass( $setup.typeCard == 'cards' ? 'row row__grid-cart' : 'row')
          }, [
            ($setup.vehicles.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.vehicles, (vehicle) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(vehicle.img ? 'col-12' : $setup.classGrid),
                    key: vehicle.identificador
                  }, [
                    _createVNode(_component_CardVehicle, {
                      typeCard: $setup.typeCard,
                      vehicle: vehicle
                    }, null, 8, ["typeCard", "vehicle"])
                  ], 2))
                }), 128))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_21,
                  ($setup.similares.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.similares, (vehicle) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(vehicle.img ? 'col-12' : $setup.classGrid),
                              key: vehicle.identificador
                            }, [
                              _createVNode(_component_CardVehicle, {
                                typeCard: $setup.typeCard,
                                vehicle: vehicle
                              }, null, 8, ["typeCard", "vehicle"])
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 2),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_pagination, {
                "current-page": $setup.paginate.current_page,
                "onUpdate:current-page": _cache[5] || (_cache[5] = ($event: any) => (($setup.paginate.current_page) = $event)),
                onCurrentChange: $setup.currentPageChange,
                "page-size": $setup.paginate.per_page,
                layout: "prev, pager, next",
                total: $setup.paginate.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}